import { SessionSettingsDialog } from "./session-settings-dialog"
import { SynthesisSessionHeader } from "./synthesis-session-header"
import { SynthesisChatPanel } from "./synthesis-chat-panel"
import type {
  SynthesisSession,
  UpdateSynthesisSessionInput,
} from "../../domain/entities/synthesis-session"

type SynthesisSessionWorkspaceProps = {
  session: SynthesisSession | undefined
  sessionId: string
  sessionLoading: boolean
  sessionError: Error | null
  settingsOpen: boolean
  onOpenSettings: () => void
  onCloseSettings: () => void
  onSaveSettings: (input: UpdateSynthesisSessionInput) => void
  isUpdating: boolean
}

export const SynthesisSessionWorkspace = ({
  session,
  sessionId,
  sessionLoading,
  sessionError,
  settingsOpen,
  onOpenSettings,
  onCloseSettings,
  onSaveSettings,
  isUpdating,
}: SynthesisSessionWorkspaceProps) => (
  <>
    <SynthesisSessionHeader
      title={session?.title?.trim() || "Conversation"}
      session={session}
      sessionLoading={sessionLoading}
      onOpenSettings={onOpenSettings}
    />

    <SynthesisChatPanel
      key={sessionId}
      sessionId={sessionId}
      session={session}
      sessionLoading={sessionLoading}
      sessionError={sessionError}
    />

    <SessionSettingsDialog
      session={session ?? null}
      open={settingsOpen}
      onClose={onCloseSettings}
      onSave={onSaveSettings}
      isPending={isUpdating}
    />
  </>
)
